<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        :columns="columns"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-add="false"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
export default {
  name: 'ParkingHeartbeat',
  components: {
    TableWrapper
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/heartbeat',
      garages: this.loadGarages()
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '心跳日期', width: '190px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择心跳日期...', type: 'dateranger' },
          { label: '车库', placeholder: '请输入绑定车库...', name: 'parkingId', width: 'auto', type: 'select', options: this.garages }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '车库', align: 'left', key: 'parking', sortable: true },
        { title: '终端标识', align: 'center', key: 'agent', sortable: true },
        { title: '终端地址', align: 'center', key: 'agentAddress', sortable: true },
        { title: '心跳时间', align: 'center', key: 'eventTime', sortable: true, width: 160 }
      ]
    }
  },
  methods: {
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    }
  }
}
</script>

